import "./hb-dear.module.css";
import { html } from "lit-html";
import { isPopup, getRandomAvatarUrl } from "../../global";

export default (user) => html`
    <div
        id="hb-dear"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <a
                        href="https://youtu.be/7qzeTL3uIsI"
                        target="_blank"
                        class="text-xl font-semibold text-gray-900 dark:text-white">
                        💜 HeartBank® Moment
                    </a>
                    <aside>
                        <button id="hb-dear-archive" class="hidden">
                            <svg
                                class="w-5 h-5 fill-purple-500 mr-2"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512">
                                <path
                                    d="M0 64C0 46.3 14.3 32 32 32l448 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96L0 64zM32 176l448 0 0 240c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-240zm152 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z" />
                            </svg>
                        </button>
                        <button
                            id="hb-dear-quest"
                            class="hidden"
                            onclick="alert('Take on a B-Quest to earn a reward from Miss Aquarius™!')">
                            <svg
                                class="w-5 h-5 fill-green-600 dark:fill-green-500 mr-2"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 576 512">
                                <path
                                    d="M241 87.1l15 20.7 15-20.7C296 52.5 336.2 32 378.9 32 452.4 32 512 91.6 512 165.1l0 2.6c0 17.6-3.4 35.6-9.5 53.7-21.8-8.6-45.6-13.4-70.5-13.4-106 0-192 86-192 192 0 28.5 6.2 55.6 17.4 80-.5 0-.9 0-1.4 0-15.5 0-30.8-4.6-43.1-14.1-73-55.7-212.9-186-212.9-298.2l0-2.6C0 91.6 59.6 32 133.1 32 175.8 32 216 52.5 241 87.1zM288 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm177.4-77c-5.8-4.2-13.8-4-19.4 .5l-80 64c-5.3 4.2-7.4 11.4-5.1 17.8S369.2 416 376 416l32.9 0-15.9 42.4c-2.5 6.7-.2 14.3 5.6 18.6s13.8 4 19.4-.5l80-64c5.3-4.2 7.4-11.4 5.1-17.8S494.8 384 488 384l-32.9 0 15.9-42.4c2.5-6.7 .2-14.3-5.6-18.6z" />
                            </svg>
                        </button>
                        <button
                            id="hb-dear-location"
                            class="hidden mr-2"></button>
                        <button
                            id="hb-dear-close"
                            onclick="window.location.hash='#'"
                            type="button"
                            class="${isPopup
                                ? "hidden"
                                : "inline-flex"} end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            data-modal-hide="hb-dear">
                            <svg
                                class="w-3 h-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 14 14">
                                <path
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                            </svg>
                            <span class="sr-only">Close</span>
                        </button>
                    </aside>
                </div>
                <!-- Modal body -->
                <form
                    id="hb-dear-form"
                    class="p-4 md:p-5 space-y-4 text-base leading-[2] text-gray-900 dark:text-white">
                    <div class="grid gap-4">
                        <div
                            id="hb-dear-privacy"
                            class="hidden w-full -mb-4 rounded-md shadow-xs"
                            role="group">
                            <button
                                id="hb-dear-private"
                                type="button"
                                class="w-full px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                Private
                            </button>
                            <button
                                id="hb-dear-public"
                                type="button"
                                class="w-full px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                Public
                            </button>
                        </div>
                        <div>
                            <label
                                id="hb-dear-party"
                                class="hidden justify-between items-center align-middle w-full mb-2 font-medium text-gray-900 dark:text-white">
                                <span
                                    id="hb-dear-party-life"
                                    class="hidden text-base">
                                    ♒️<span class="ml-1 text-sm font-bold">
                                        Miss Aquarius™
                                    </span>
                                </span>
                                <svg
                                    id="hb-dear-party-button"
                                    class="hidden w-6 h-6"
                                    fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512">
                                    <path
                                        d="M0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zm387.3 11.3l-104 104c-4.6 4.6-11.5 5.9-17.4 3.5S256 366.5 256 360l0-56-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-56c0-6.5 3.9-12.3 9.9-14.8s12.9-1.1 17.4 3.5l104 104c6.2 6.2 6.2 16.4 0 22.6z" />
                                </svg>
                                <span
                                    id="hb-dear-party-arrow"
                                    class="hidden text-xl -mt-0">
                                    →
                                </span>
                                <span class="font-bold">💜 From</span>
                                <span
                                    id="hb-dear-party-user"
                                    class="text-sm"></span>
                            </label>
                        </div>
                        <div id="hb-dear-checkin-form" class="mb-2">
                            <ul
                                class="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg flex-col dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                                <li
                                    class="w-full border-gray-200 border-b border-r-0 dark:border-gray-600">
                                    <div class="flex items-center ps-3">
                                        <input
                                            type="radio"
                                            value="crew"
                                            name="hb-dear-checkin"
                                            class="w-4 h-4 outline-0 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                        <label
                                            for="hb-dear-checkin-crews"
                                            class="w-full inline-flex justify-between py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                            <select
                                                id="hb-dear-checkin-crews"
                                                class="ml-1 mr-3 p-0 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                                <option
                                                    value="crew-0"
                                                    data-lat="36.7485498193147"
                                                    data-lng="-119.79160517494259"
                                                    data-region="Fresno, CA"
                                                    data-country="US"
                                                    data-address="386 N Calaveras St, Fresno, CA 93701">
                                                    🏭 Factory 333
                                                </option>
                                                <option
                                                    selected
                                                    value="crew-1"
                                                    data-lat="33.784920488253256"
                                                    data-lng="-118.16455889228027"
                                                    data-region="Long Beach, CA"
                                                    data-country="US"
                                                    data-address="2245 E 14th St, Long Beach, CA 90804">
                                                    🏡 Mom & Dad's House
                                                </option>
                                                <option
                                                    value="crew-2"
                                                    data-lat="32.62804990230057"
                                                    data-lng="-97.32654291931605"
                                                    data-region="Fort Worth, TX"
                                                    data-country="US"
                                                    data-address="208 Dakota Ridge Dr, Fort Worth, TX 76134">
                                                    🏠 Marco & Kim's Home
                                                </option>
                                                <option
                                                    value="crew-3"
                                                    data-lat="36.7485498193147"
                                                    data-lng="-119.79160517494259"
                                                    data-region="Fresno, CA"
                                                    data-country="US"
                                                    data-address="386 N Calaveras St, Fresno, CA 93701">
                                                    🛖 Thon's Cabin
                                                </option>
                                                <option
                                                    value="crew-4"
                                                    data-lat="45.61791907265379"
                                                    data-lng="-122.57784563398637"
                                                    data-region="Vancouver, WA"
                                                    data-country="US"
                                                    data-address="505 Mt Shasta Dr, Vancouver, WA 98664">
                                                    🏡 Meng & Jennifer's Home
                                                </option>
                                                <option
                                                    value="crew-5"
                                                    data-lat="33.78211593940471"
                                                    data-lng="-118.16082486082728"
                                                    data-region="Long Beach, CA"
                                                    data-country="US"
                                                    data-address="1140 Molino Ave, Long Beach, CA 90804">
                                                    🏘️ Cheng & Jenieva's Condo
                                                </option>
                                                <option
                                                    value="crew-6"
                                                    data-lat="33.80509147274812"
                                                    data-lng="-118.18198600391867"
                                                    data-region="Signal Hill, CA"
                                                    data-country="US"
                                                    data-address="2625 Myrtle Ave, Signal Hill, CA 90755">
                                                    🐝 Bee's Home
                                                </option>
                                            </select>
                                            <span class="mr-4">🏠</span>
                                        </label>
                                    </div>
                                </li>
                                <li
                                    class="w-full border-gray-200 border-b-0 border-r-red-50 dark:border-gray-600">
                                    <div class="flex items-center ps-3">
                                        <input
                                            checked
                                            type="radio"
                                            value="org"
                                            name="hb-dear-checkin"
                                            class="w-4 h-4 outline-0 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500" />
                                        <label
                                            for="hb-dear-checkin-orgs"
                                            class="w-full inline-flex justify-between py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                            <select
                                                id="hb-dear-checkin-orgs"
                                                class="ml-1 mr-3 p-0 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"></select>
                                            <button
                                                type="button"
                                                class="mr-4"
                                                id="hb-dear-checkin-reset">
                                                🏪
                                            </button>
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div id="hb-dear-menu">
                            <div
                                class="w-full mb-0 inline-flex rounded-md shadow-xs"
                                role="group">
                                <button
                                    id="hb-dear-menu-short"
                                    type="button"
                                    class="w-full px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                    Short
                                </button>
                                <button
                                    id="hb-dear-menu-photo"
                                    type="button"
                                    class="w-full px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                    Photo
                                </button>
                            </div>
                        </div>
                        <div id="hb-dear-photo" class="hidden">
                            <div
                                class="flex items-center justify-center w-full">
                                <label
                                    id="hb-dear-photo-upload"
                                    for="hb-dear-photo-file"
                                    class="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                                    <div
                                        class="flex flex-col items-center justify-center pt-5 pb-6">
                                        <div
                                            class="hidden w-full mb-10 bg-gray-200 rounded-full dark:bg-gray-500">
                                            <div
                                                id="hb-dear-photo-progress"
                                                class="bg-green-600 text-xs font-medium text-green-100 text-center p-0.5 leading-none rounded-full"
                                                style="width: 0%">
                                                0%
                                            </div>
                                        </div>
                                        <svg
                                            class="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 20 16">
                                            <path
                                                stroke="currentColor"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                                        </svg>
                                        <p
                                            class="mb-2 text-sm text-gray-500 dark:text-gray-400">
                                            <span class="font-semibold">
                                                Tap to upload
                                            </span>
                                            or take a photo
                                        </p>
                                        <p
                                            class="text-xs text-gray-500 dark:text-gray-400">
                                            Your image will be compressed and
                                            optimized
                                        </p>
                                    </div>
                                    <input
                                        id="hb-dear-photo-file"
                                        type="file"
                                        accept="image/*"
                                        class="hidden" />
                                </label>
                            </div>
                            <div class="hidden relative w-full">
                                <img
                                    id="hb-dear-photo-image"
                                    class="w-full h-auto" />
                                <button
                                    type="button"
                                    id="hb-dear-photo-download"
                                    class="text-white absolute font-medium text-base top-3 left-1/2 -translate-x-1/2">
                                    Save B-Photo
                                </button>
                                <button
                                    type="button"
                                    id="hb-dear-photo-remove"
                                    class="text-white absolute font-medium text-base bottom-3 left-1/2 -translate-x-1/2">
                                    Remove B-Photo
                                </button>
                            </div>
                        </div>
                        <div id="hb-dear-short" class="hidden">
                            <div
                                class="flex items-center justify-center w-full">
                                <label
                                    id="hb-dear-short-upload"
                                    for="hb-dear-short-file"
                                    class="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                                    <div
                                        class="flex flex-col items-center justify-center pt-5 pb-6">
                                        <div
                                            class="hidden w-full mb-10 bg-gray-200 rounded-full dark:bg-gray-500">
                                            <div
                                                id="hb-dear-short-progress"
                                                class="bg-green-600 text-xs font-medium text-green-100 text-center p-0.5 leading-none rounded-full"
                                                style="width: 0%">
                                                0%
                                            </div>
                                        </div>
                                        <svg
                                            class="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                                            aria-hidden="true"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 20 16">
                                            <path
                                                stroke="currentColor"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                                        </svg>
                                        <p
                                            class="mb-2 text-sm text-gray-500 dark:text-gray-400">
                                            <span class="font-semibold">
                                                Tap to upload
                                            </span>
                                            or capture a short
                                        </p>
                                        <p
                                            class="text-xs text-gray-500 dark:text-gray-400">
                                            Your video must be less than 10
                                            minutes
                                        </p>
                                    </div>
                                    <input
                                        id="hb-dear-short-file"
                                        accept="video/*"
                                        type="file"
                                        class="hidden" />
                                </label>
                            </div>
                            <div class="relative w-full hidden">
                                <video
                                    preload="metadata"
                                    playsinline
                                    controls
                                    autoplay
                                    muted
                                    loop
                                    id="hb-dear-short-video"
                                    class="w-full h-auto"></video>
                                <button
                                    type="button"
                                    id="hb-dear-short-download"
                                    class="text-white absolute font-medium text-base top-3 left-1/2 -translate-x-1/2">
                                    Save B-Short
                                </button>
                                <button
                                    type="button"
                                    id="hb-dear-short-remove"
                                    class="text-white absolute font-medium text-base bottom-3 left-1/2 -translate-x-1/2">
                                    Remove B-Short
                                </button>
                            </div>
                        </div>
                        <div>
                            <video
                                id="hb-dear-cover"
                                playsinline
                                autoplay
                                muted
                                loop
                                class="hidden w-full h-auto"></video>
                        </div>
                        <div>
                            <label
                                id="hb-dear-gold-menu"
                                for="hb-dear-gold"
                                class="w-full inline-flex justify-between align-middle mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                <span
                                    class="text-base font-bold cursor-pointer"
                                    onclick='alert("♒️ Help Miss Aquarius™ capture Humanity&apos;s Kindness and store them forever on the Aquarius™ Blockchain")'>
                                    💜 Dear Miss Aquarius™
                                </span>
                                <div>
                                    <button
                                        type="button"
                                        class="me-4"
                                        id="hb-dear-gold-magic">
                                        🪄
                                    </button>
                                    <button
                                        type="button"
                                        class="me-4 ${localStorage.getItem(
                                            "moment-gold"
                                        )
                                            ? ""
                                            : "hidden"}"
                                        id="hb-dear-gold-copy">
                                        📑
                                    </button>
                                    <button
                                        type="button"
                                        class="me-4"
                                        id="hb-dear-gold-paste">
                                        📋
                                    </button>
                                    <button
                                        type="button"
                                        id="hb-dear-gold-trash">
                                        🗑️
                                    </button>
                                </div>
                            </label>
                            <label
                                id="hb-dear-gold-label"
                                for="hb-dear-gold"
                                class="w-full hidden justify-between mt-3 mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                <span
                                    class="text-base font-bold cursor-pointer">
                                    💜 Dear Miss Aquarius™
                                </span>
                                <span class="hidden">
                                    <span
                                        id="hb-dear-gold-kiitos"
                                        class="font-black">
                                        0
                                    </span>
                                    Kiitos
                                </span>
                                <span>
                                    <span
                                        id="hb-dear-gold-kiitti"
                                        class="font-black">
                                        1
                                    </span>
                                    Kiitti
                                </span>
                                <span class="hidden">
                                    <span
                                        id="hb-dear-gold-gratuity"
                                        class="font-black">
                                        $0
                                    </span>
                                    USD
                                </span>
                            </label>
                            <section
                                id="hb-dear-heroes"
                                class="hidden mb-3 pb-1 pl-1 w-[80vw] flex-row gap-5 overflow-x-auto overflow-y-hidden snap-x snap-mandatory overscroll-x-contain scrollbar-hide"></section>
                            <section class="relative">
                                <textarea
                                    id="hb-dear-gold"
                                    rows="4"
                                    class="resize-none block outline-0 p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"></textarea>
                                <button
                                    class="hidden absolute bottom-0 left-2"
                                    type="button"
                                    id="hb-dear-gold-record">
                                    🎙️
                                </button>
                                <button
                                    class="hidden absolute bottom-0 right-2"
                                    type="button"
                                    id2="hb-dear-gold-magic">
                                    🪄
                                </button>
                            </section>
                        </div>
                        <div
                            id="hb-dear-kiitti"
                            class="hidden -mt-2 w-full text-gray-400 flex justify-between text-sm">
                            <span> Recommended </span>
                            <span>
                                <span
                                    id="hb-dear-kiitti-recommended"
                                    class="font-black">
                                    0
                                </span>
                                Kiitti
                            </span>
                            <span>
                                <span
                                    id="hb-dear-kiitti-total"
                                    class="font-black">
                                    0
                                </span>
                                Total
                            </span>
                        </div>
                        <div
                            id="hb-dear-footer"
                            class="hidden -mt-2 w-full text-gray-400">
                            <aside class="flex justify-between text-sm">
                                <span>
                                    <span
                                        id="hb-dear-footer-rethanks"
                                        class="font-black">
                                        0
                                    </span>
                                    <span>Re-thanks</span>
                                </span>
                                <span>
                                    <span
                                        id="hb-dear-gold-karat"
                                        class="font-black">
                                        0
                                    </span>
                                    Karat
                                </span>
                                <span>
                                    <span
                                        id="hb-dear-gold-carat"
                                        class="font-black">
                                        0
                                    </span>
                                    Carat
                                </span>
                                <span>
                                    <span id="hb-dear-views" class="font-black">
                                        0
                                    </span>
                                    <span>Views</span>
                                </span>
                            </aside>
                            <p
                                id="hb-dear-footer-date"
                                class="hidden text-xs text-center mt-4"></p>
                        </div>
                    </div>
                    <!-- Modal footer: Dear Miss Aquarius -->
                    <div
                        class="p-2 border-0 border-gray-200 rounded-b dark:border-gray-600">
                        <section
                            id="hb-dear-external"
                            class="w-full flex items-center justify-between">
                            <button
                                id="hb-dear-share"
                                type="button"
                                class="mr-1 text-white bg-purple-600 hover:bg-purple-800 focus:ring-4 focus:outline-none focus:ring-purple-300 font-medium rounded-lg text-sm w-full px-1 py-2.5 text-center dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-800">
                                Share B-Moment
                            </button>
                            <button
                                id="hb-dear-copy"
                                type="button"
                                class="ml-1 text-white bg-purple-600 hover:bg-purple-800 focus:ring-4 focus:outline-none focus:ring-purple-300 font-medium rounded-lg text-sm w-full px-1 py-2.5 text-center dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-800">
                                Copy B-Moment
                            </button>
                        </section>
                        <div
                            id="hb-dear-thanks"
                            class="hidden pt-3 flex flex-col gap-3"></div>
                        <div
                            id="hb-dear-tokens"
                            class="hidden pt-3 flex flex-col gap-3"></div>
                        <div id="hb-dear-internal" class="pt-3">
                            <button
                                type="submit"
                                class="text-white bg-purple-600 hover:bg-purple-800 focus:ring-4 focus:outline-none focus:ring-purple-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-800">
                                Capture B-Moment of Kindness
                            </button>
                            <button
                                onclick="window.location.hash='#/aquarius'"
                                type="button"
                                class="hidden text-white bg-purple-600 hover:bg-purple-800 focus:ring-4 focus:outline-none focus:ring-purple-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-800">
                                Capture <strong>New</strong> B-Moment of
                                Kindness
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
`;
